import graphql from "babel-plugin-relay/macro";
import { max } from "lodash";
import { useFragment } from "react-relay";

import { useDepartmentMaxGolfCourseBookingWindow_department$key } from "./__generated__/useDepartmentMaxGolfCourseBookingWindow_department.graphql";

export const useDepartmentMaxGolfCourseBookingWindow = (
  departmentRef: useDepartmentMaxGolfCourseBookingWindow_department$key | null
) => {
  const department = useFragment(
    useDepartmentMaxGolfCourseBookingWindowFragment,
    departmentRef
  );

  const golfFacilities =
    department?.facilities?.edges?.flatMap((e) =>
      e?.node?.type === "GOLF_COURSE" ? [e.node] : []
    ) || [];

  const windowDays = golfFacilities?.flatMap((facility) => {
    const publicBookingWindowDays = facility?.publicBookingWindowDays;
    const memberBookingWindowDays = facility?.memberBookingWindowDays;
    return publicBookingWindowDays && memberBookingWindowDays
      ? [publicBookingWindowDays, memberBookingWindowDays]
      : [];
  });

  return max(windowDays) || 30;
};

const useDepartmentMaxGolfCourseBookingWindowFragment = graphql`
  fragment useDepartmentMaxGolfCourseBookingWindow_department on Department {
    facilities {
      edges {
        node {
          id
          type
          publicBookingWindowDays
          memberBookingWindowDays
          club {
            supportsPrivate
          }
        }
      }
    }
  }
`;
